import {hideLoading, showLoading} from 'stores/actions/appStateAction';
import {batch} from 'react-redux';
import {FmlxRadioButton} from 'fmlx-common-ui';
import {SetupWizardStep} from 'constants/SetupWizardEnum';
import {setWizardAllowedNext} from 'stores/actions/wizardStateAction';
import {
  CommonButtonLabel,
  FastRobotErrorcode,
  ModalType,
  SignalREvent,
  TrayText,
  ViewMode,
} from '../../constants/dataEnum';
import {parseMessage} from '../../lib/stringHelper';
import {hideModal, showModal} from '../actions/modalStateAction';
import {setIsTrayAttached, setTrayData} from '../actions/trayCalibrationStateAction';
import {showModalType} from '../actions/typedModalAction';
import {setErrorCodeNumber} from './commonBusiness';
// eslint-disable-next-line import/no-cycle
import {showModalSimplified} from './commonModalBusiness';
import {abortProtocol, getTrayDataById} from './instrumentBusiness';
import {navigateSetupWizardToStep} from './setupWizardBusiness/setupWizardNavigationBusiness';
import {isUserOperator} from './userManagementBusiness';

export const showMissingTrayModal = (isNeedRecovery, successCallback, failedCallback) => async (dispatch) => {
  dispatch(hideModal(true));
  await dispatch(setErrorCodeNumber(FastRobotErrorcode.MissingTray));
  dispatch(setIsTrayAttached(false));

  dispatch(
    showModalType(ModalType.MISSING_TRAY_ERROR, {
      isNeedRecovery,
      successCallback: successCallback || (() => {}),
      failedCallback: failedCallback || (() => {}),
    }),
  );
};

export const showMissingTrayPutLabwareInTrayModal = (callback) => (dispatch) => {
  const title = parseMessage('modal.missingTray.putLabwareOnDeck.title');
  const body = parseMessage('modal.missingTray.putLabwareOnDeck.text', {asComponent: true});

  const buttonConfirm = [{label: parseMessage(CommonButtonLabel.CONFIRM), onClick: callback}];

  // add close button by UX (chusni)
  dispatch(showModalSimplified(title, body, buttonConfirm, {hideClose: false}));
};

export const showModalSwitchTrayType = (callback) => async (dispatch, getState) => {
  let trayIdValue = null;
  const {trayCalibrationState} = getState();
  const {id} = trayCalibrationState;
  const changeTrayById = async () => {
    dispatch(showLoading('Loading...'));
    dispatch(getTrayDataById(Number(trayIdValue), trayIdValue))
      .then((res) => {
        batch(() => {
          dispatch(setTrayData(res.tray));
          dispatch(hideLoading());
        });
      })
      .catch((err) => {
        console.log(SignalREvent.SET_TRAY_ID, 'ERROR ', err);
        dispatch(hideLoading());
      });
  };

  const setTrayIdValue = (value) => {
    // eslint-disable-next-line no-unsafe-optional-chaining
    trayIdValue = value?.index + 1;
  };

  const itemsTrayType = Object.values(TrayText).map((item) => ({content: item, hint: '', type: null, disabled: false}));

  const content = (
    <FmlxRadioButton
      selectedIndex={id - 1}
      size={FmlxRadioButton.Size.SMALL}
      items={itemsTrayType}
      onChange={setTrayIdValue}
    />
  );

  const buttonAction = [
    {
      className: 'btn-lg',
      style: 'primary',
      handlerClick: async () => {
        dispatch(hideModal());
        await changeTrayById();
        callback();
      },
      text: parseMessage('explorer.newProtocol.modal.ok'),
    },
    {
      className: 'btn-lg',
      style: 'secondary',
      handlerClick: () => {
        dispatch(hideModal());
      },
      text: parseMessage('explorer.newProtocol.modal.cancel'),
    },
  ];

  dispatch(
    showModal(
      parseMessage('explorer.newProtocol.modal.title'),
      content,
      buttonAction,
      () => dispatch(hideModal()),
      '',
      false,
      null,
    ),
  );
};

export function showTrayUncalibratedModal(callback = () => {}, abortCallback = () => {}) {
  return async (dispatch, getState) => {
    const {tipState, appState} = getState();
    const {viewMode} = appState;

    await dispatch(setErrorCodeNumber(FastRobotErrorcode.TrayUncalibrated));
    const isOperator = dispatch(isUserOperator());

    let bodyLocaleId;
    let isDefaultTrayUncalibratedModal = false;

    switch (viewMode) {
      case ViewMode.PLATE_TYPE_EDITOR:
        bodyLocaleId = 'modal.trayUncalibrated.text.plateDefinition';
        break;
      case ViewMode.SETUP_WIZARD:
        bodyLocaleId = 'modal.trayUncalibrated.text.setupWizard';
        break;
      default:
        bodyLocaleId = 'modal.trayUncalibrated.text';
        isDefaultTrayUncalibratedModal = true;
    }

    const firstButtonLabel = isDefaultTrayUncalibratedModal
      ? 'modal.trayUncalibrated.firstButton'
      : CommonButtonLabel.GOT_IT;

    const title = parseMessage('modal.trayUncalibrated.title');
    const body = parseMessage(bodyLocaleId);

    const firstButtonCallback = async () => {
      await dispatch(hideModal());
      if (!isOperator) {
        const {showModal: showSetManualTipLocationModal} = tipState;

        if (showSetManualTipLocationModal) {
          dispatch(abortProtocol(true));
        }

        if (viewMode !== ViewMode.SETUP_WIZARD) {
          callback();
        } else {
          dispatch(navigateSetupWizardToStep(SetupWizardStep.TRAY_CALIBRATION));
          dispatch(setWizardAllowedNext(false));
        }
      }
    };

    dispatch(
      showModalSimplified(title, body, [
        {
          label: parseMessage(firstButtonLabel),
          onClick: firstButtonCallback,
        },
        isDefaultTrayUncalibratedModal && {
          label: parseMessage(CommonButtonLabel.ABORT),
          onClick: async () => {
            await dispatch(hideModal());
            abortCallback();
          },
        },
      ]),
    );
  };
}
